import React from "react";
import Demo from "./Demo";

function App() {
  return (
    <div className="app">
      <Demo />
    </div>
  );
}

export default App;
